// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export async function postCardJson(u, o, m) {
  const r = await fetch(u, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(o),
      signal: m
    }),
    g = await r.json();
  if (!r.ok) throw new Error(g.error || "Не удалось выполнить запрос");
  return g;
}
export function fetchCardUniverses(u) {
  return postCardJson("/api/cards/universes", {
    initData: u
  });
}
export function fetchCardPreview(u, o, m) {
  return postCardJson("/api/cards/preview", {
    initData: u,
    universe: o
  }, m);
}
export function changeCardUniverse(u, o) {
  return postCardJson("/api/cards/universe", {
    initData: u,
    universe: o
  });
}
export function openCards(u, o, m) {
  return postCardJson("/api/cards/open", {
    initData: u,
    amount: o,
    requestId: m
  });
}
